// frontend/src/pages/admin/AdminOverviewPage.tsx

import { useEffect, useState } from 'react';
import { adminService } from '../../services/admin.service';
import { AdminUserStats, AdminOverview } from '../../types/admin.types';
import {
  Users,
  GraduationCap,
  Heart,
  Flame,
  Ban,
  Gem,
  BookOpen,
  Book,
  Target,
  FileCheck2,
  CheckCircle2,
  BarChart3
} from 'lucide-react';

export function AdminOverviewPage() {
  const [userStats, setUserStats] = useState<AdminUserStats | null>(null);
  const [overview, setOverview] = useState<AdminOverview | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([adminService.getUserStats(), adminService.getOverview()])
      .then(([stats, ov]) => {
        setUserStats(stats);
        setOverview(ov);
      })
      .catch((err) => setError(err instanceof Error ? err.message : 'Veri alınamadı.'))
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) return <div className="courses-loading">Yükleniyor...</div>;
  if (error) return <div className="courses-error">{error}</div>;
  if (!userStats || !overview) return null;

  const cards = [
    { icon: <Users size={22} color="#00AEEF" />, label: 'Toplam Kullanıcı', value: userStats.totalUsers },
    { icon: <GraduationCap size={22} color="#10C27A" />, label: 'Öğrenci', value: userStats.totalStudents },
    { icon: <Heart size={22} color="#7C3AED" />, label: 'Veli', value: userStats.totalParents },
    { icon: <Flame size={22} color="#FF7043" />, label: 'Bu Hafta Aktif', value: userStats.activeThisWeek },
    { icon: <Ban size={22} color="#EF4444" />, label: 'Banlı Kullanıcı', value: userStats.bannedUsers },
    { icon: <Gem size={22} color="#F59E0B" />, label: 'Premium Kullanıcı', value: userStats.premiumUsers, note: 'Ödeme sistemi aktif' },
  ];

  const contentCards = [
    { icon: <BookOpen size={22} color="#00AEEF" />, label: 'Kurs', value: overview.totalCourses },
    { icon: <Book size={22} color="#10C27A" />, label: 'Ders', value: overview.totalLessons },
    { icon: <Target size={22} color="#EF4444" />, label: 'Proje', value: overview.totalProjects },
    { icon: <FileCheck2 size={22} color="#7C3AED" />, label: 'Proje Gönderimi', value: overview.totalSubmissions },
    { icon: <CheckCircle2 size={22} color="#F59E0B" />, label: 'Quiz Denemesi', value: overview.totalQuizAttempts },
  ];

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          Genel Bakış <BarChart3 size={28} color="#00AEEF" />
        </h1>
        <p>Platform geneli özet istatistikler</p>
      </header>

      <h3 className="admin-section-title">Kullanıcılar</h3>
      <div className="admin-stats-grid">
        {cards.map((c) => (
          <div className="admin-stat-card" key={c.label}>
            <div className="admin-stat-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {c.icon}
            </div>
            <div className="admin-stat-value">{c.value.toLocaleString('tr-TR')}</div>
            <div className="admin-stat-label">{c.label}</div>
            {c.note && <div className="admin-stat-note">{c.note}</div>}
          </div>
        ))}
      </div>

      <h3 className="admin-section-title" style={{ marginTop: 32 }}>
        İçerik
      </h3>
      <div className="admin-stats-grid">
        {contentCards.map((c) => (
          <div className="admin-stat-card" key={c.label}>
            <div className="admin-stat-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {c.icon}
            </div>
            <div className="admin-stat-value">{c.value.toLocaleString('tr-TR')}</div>
            <div className="admin-stat-label">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
